export const below = -1;
export const base = 0;
export const above = 1;
export const dropdown = 10;
export const nav = 20;
export const header = 30;
export const sidepanel = 80;
export const modal = 90;
export const alert = 100;
export default {
  "below": -1,
  "base": 0,
  "above": 1,
  "dropdown-below": 9,
  "dropdown": 10,
  "dropdown-above": 11,
  "nav-below": 19,
  "nav": 20,
  "nav-above": 21,
  "header-below": 29,
  "header": 30,
  "header-above": 31,
  "sidepanel-below": 79,
  "sidepanel": 80,
  "sidepanel-above": 81,
  "modal-below": 89,
  "modal": 90,
  "modal-above": 91,
  "alert-below": 99,
  "alert": 100,
  "alert-above": 101,
  "autocomplete-popover": 2147483647
}
;